import { Component, OnInit, ViewChild, ElementRef,Optional } from '@angular/core';
import { AngularEditorComponent } from '@kolkov/angular-editor';
import { AngularEditorService } from '@kolkov/angular-editor';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Platform, IonRouterOutlet,NavController,ModalController,ToastController, ActionSheetController,
    IonContent,
    LoadingController, AlertController, PickerController } from '@ionic/angular';

import { GlobalVars } from '../../../providers/globalVars';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase,AngularFireList } from '@angular/fire/database';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Imgupload } from '../../../providers/imgupload';
import { DragulaService } from 'ng2-dragula';
import * as autoScroll from 'dom-autoscroller';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase/app';
//import { Clipboard } from '@ionic-native/clipboard/ngx';
import { DoublecatmodalPage } from '../../support/doublecatmodal/doublecatmodal.page';
import { msgfunc } from '../../../providers/msgfunc';
import { pointfunc } from '../../../providers/pointfunc';
import { BasicpopupPage } from './basicpopup/basicpopup.page';
import { InapplinkPage } from './inapplink/inapplink.page';
import { AddmapPage } from './addmap/addmap.page';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { ImagePicker } from '@ionic-native/image-picker/ngx';

//import * from 'url-metadata';
declare var google;
declare var require: any;
@Component({
  selector: 'app-post',
  templateUrl: './post.page.html',
  styleUrls: ['./post.page.scss'],
})

export class PostPage implements OnInit {

  @ViewChild("ipaddress") public searchElementRef: ElementRef;
  @ViewChild(AngularEditorComponent) editor:AngularEditorComponent;
  loclan: string;
  chid:any;
  chname:any;
  chloc:any;
  imgtype:any = 'together';
  itemid:any;
  serviceid:any;
  forms:any = [];
  selections:any = [];
  defaultpost:any = 'notset';
  normalForm : FormGroup;
  usersettingForm : FormGroup[];
  formsp:any;  

  btmtoolbar:boolean = false;

  notification:boolean = true;
  categories:any[]=[];
  subcategories:any[]=[];
  category:any;
  
  lat:any=null;
  lng:any=null;
  mapStyle: any = "style=element:geometry.fill%7Csaturation:-60%7Cweight:2";
  mapWidth:number = window.innerWidth;
  mapHeight:number = 200;
  mapshow:boolean;
  preaddress:any;
  images_post:any[] = [];
  imagethumbs_post:any[] = /*[{url:'data:image/png;base64,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'},
{url:'data:image/png;base64,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'},
{url:'data:image/png;base64,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'},
{url:'data:image/png;base64,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'},


  ]*/
  [];
  imagethumb;
  imgloaddone:boolean;
  selectedimg:any;
  scrollable:any='';
  selectedform:any = -1;
  commenttype:any = null;
  liketype:any = null;
  
  editorConfig: AngularEditorConfig;
  title:any = '';
  content:any = ''
  subs = new Subscription();

  privateitem:boolean = false;
  urladdr:any;
  publiccommunity:boolean = false;
  categorytype:any = 'normal';

  modal;
  ch;
  item;
  cangoback:boolean = false;
  chowner:boolean = false;
  autosave:any;
  closerequest:boolean = false;

  formcount:any[] = [];
  hasstate:any = null;

  colorshow;
  bgcolorshow;
  fontsizeshow;
  alignshow;
  fonttypeshow;
  txtmenushow;
  
  didimgclick:boolean = false;
  uploadingimgs:boolean = false;
  @ViewChild(IonContent, {static: true}) ioncontent: IonContent;
  constructor(public editorservice:AngularEditorService,private navCtrl:NavController, public afDB: AngularFireDatabase,
   @Optional() private outlet: IonRouterOutlet,private dragulaService: DragulaService,public pickerCtrl:PickerController 
   ,public translate: TranslateService,
   public modalCtrl:ModalController, private toastCtrl: ToastController ,public alertCtrl: AlertController, public loadctrl:LoadingController,
   public afAuth: AngularFireAuth,private msgfunc:msgfunc,private actionsheetCtrl:ActionSheetController,
   private pointfunc:pointfunc,
   //private clipboard: Clipboard,
   private platform: Platform,private imagePicker: ImagePicker,private fs:AngularFirestore,
   private imguploadpost: Imgupload,public fb: FormBuilder,private gv: GlobalVars,private route: ActivatedRoute) {
    
    let ph;
    this.translate.get('Fill content here.').subscribe(res=>{ph=res});

    this.editorConfig = {
    editable: true,
    spellcheck:false,
    translate: 'no' ,
    defaultFontSize: '4',
    height:'100%',//'calc(100vh - 200px)',
    showToolbar:false,
    placeholder:ph,
    customClasses: [ // optional
        {
            name: "quote",
            class: "quote",
        }
    ]
    }
    if(gv.getLoc() && gv.getLan())
        this.loclan = gv.getLoc() + '_' + gv.getLan();
    else
        this.loclan = 'cairns_kr';
    
    if(this.route.snapshot.paramMap.get('ch'))
      this.chid = this.route.snapshot.paramMap.get('ch');
    if(this.route.snapshot.paramMap.get('id'))
      this.itemid = this.route.snapshot.paramMap.get('id');
    
    this.usersettingForm = [this.fb.group({}),this.fb.group({}),this.fb.group({})];
  
    this.subs.add(this.dragulaService.drag("imagethumb")
      .subscribe(({ name, el, source }) => {
      autoScroll(el.parentNode, {
        margin: 50,
        maxSpeed: 5,
        scrollWhenOutside: false,
        autoScroll: function () {
          const drake = dragulaService.find('imagethumb');
          return drake.drake.dragging; // of course test if !!drake
        },
      });
      })
    );
    
    this.dragulaService.drag("imagethumb").subscribe(_=>{
         this.scrollable = true
    })
    dragulaService.dragend("imagethumb").subscribe(_=>{
        this.scrollable = false
    })

    this.dragulaService.drop("imagethumb").subscribe(_=>{
    var tempimg = [];
    for(var i = 0; i < this.imagethumbs_post.length ; i++)
    {
        for(var j=0; j < this.images_post.length; j++)
        {
          if(this.images_post[j].path == this.imagethumbs_post[i].path.replace("tb_", ""))
                tempimg.push(this.images_post[j]);
        }
    } 
    this.images_post = tempimg;
    })
    }

    tempsave(){
        if(this.hascontent())
        {
        let temppost;
        
        if(this.selectedform > -1)
        {
            temppost =
            {
            chid:this.chid,
            form:this.usersettingForm[this.selectedform].value,
            images: this.images_post,
            imagethumb: this.imagethumbs_post,
            lat: this.lat,
            lng: this.lng,
            categoryId: this.chid,
            category: this.category,
            categorytype: this.categorytype,
            communityname: this.chname,
            loc: this.chloc,
            imgtype: this.imgtype,
            selectedform: this.selectedform,
            commenttype: this.commenttype,
            liketype: this.liketype,
            state: this.hasstate,
            selections: this.selections
            }  
        }
        else
        {
            temppost = 
            {
            chid:this.chid,
            title:this.title,
            description:this.content,
            images:this.images_post,
            imagethumb:this.imagethumbs_post,
            lat:this.lat,
            lng:this.lng,
            categoryId: this.chid,
            category:this.category,
            categorytype:this.categorytype,
            communityname:this.chname,
            loc: this.chloc,
            imgtype:this.imgtype,
            selectedform:this.selectedform,
            commenttype:this.commenttype,
            liketype:this.liketype,
            state:this.hasstate
            }
        }
        this.gv.setPostcover(this.chid,temppost)  
        }   
    }
    hascontent(){
        if(this.selectedform > -1)
        {
            let hasformdata = false;
            let fv = this.usersettingForm[this.selectedform].value;
            for(let i = 0; i < Object.keys(fv).length; i++)
            {
                if(fv[Object.keys(fv)[i]])
                {
                    hasformdata = true;
                    break;
                }
            }
            
            if(hasformdata || (this.images_post && this.images_post.length > 0) 
                || (this.imagethumbs_post && this.imagethumbs_post.length > 0) || this.lat 
                || this.lng || (this.selections && this.selections.length > 0))
                return true;
            else
                return false;
        }
        else
        {
            if(this.title || this.content || (this.images_post && this.images_post.length > 0) 
                || (this.imagethumbs_post && this.imagethumbs_post.length > 0) || this.lat || this.lng)
                return true;
            else
                return false;
        }
    }

    ionViewWillLeave(){
        if(!this.closerequest)
        {
            if(this.hascontent())
            {
            this.translate.get("Posting is temporary saved.").subscribe(res=>{
            this.presentToast(res);});
            this.tempsave();
            }
        }    
    }

    async close(){
    this.closerequest = true;
    if(this.hascontent())
    {
        let msg,cancel,savenleave,leave;
        this.translate.get('This posting was not submitted. Are you sure to exit?').subscribe(res=>{msg=res});
        this.translate.get('Cancel').subscribe(res=>{cancel=res});
        this.translate.get('Exit with temporary save').subscribe(res=>{savenleave=res});
        this.translate.get('Exit').subscribe(res=>{leave=res});

        const alert = await this.alertCtrl.create({
        message: msg,
        buttons: [
        {
            text: cancel,
            role: 'cancel'
        },{
            text: savenleave,
            handler: () => {
                this.tempsave();
                this.translate.get("Saved temporary.").subscribe(res=>{
                this.presentToast(res);});
                this.pageleave();    
            }
        },{
            text: leave,
            handler: () => {
                this.gv.setPostcover(this.chid,null);
                this.pageleave();   
            }
        }]
        })
        await alert.present();
    }
    else
        this.pageleave();  
    }

    pageleave(){
        if(`${this.modal}` != 'undefined') 
        this.modalCtrl.dismiss();
        if(this.cangoback)
        {this.navCtrl.pop();}
        else
        this.navCtrl.navigateBack(''); 
    }

    changenoti(){
        if(this.notification)
        {
            this.notification = false;
            this.translate.get("Submit without alram.").subscribe(res=>{
            this.presentToast(res);});
        }
        else
        {
            this.notification = true;
            this.translate.get("Submit with new post alarm.").subscribe(res=>{
            this.presentToast(res);});
        }
    }

   setdata(){
    this.fs.collection('post').doc(this.itemid).get().subscribe(datasnap=>{
        var data = datasnap.data();
        if(data){
        this.images_post = data.images? data.images:[];
        if(this.images_post.length)
            this.selectedimg = this.images_post[0].url;
        this.category = data.category;
        this.imagethumbs_post = data.imagethumb? data.imagethumb:[];
        this.selectedform = data.selectedform>-1?data.selectedform:-1;
        this.commenttype = data.commenttype?data.commenttype:null;
        this.liketype = data.liketype?data.liketype:null;
        this.imgtype = data.imgtype?data.imgtype:null;
        this.hasstate = data.state?data.state:null;
        
        if(!data.formdata || this.selectedform == -1)
        {
            this.title = data.title;
            this.content = data.description.replace(/\n/ig, '<br>');
        }
        else
        {
           this.setfield(this.forms[this.selectedform], this.selectedform);
           if(this.forms.length)
              this.setfieldandval(data.formdata.fieldlist)
           else
            {
                setTimeout(_=>{
                    if(this.forms.length)
                        this.setfieldandval(data.formdata.fieldlist)
                    else
                        setTimeout(_=>{
                    if(this.forms.length)
                        this.setfieldandval(data.formdata.fieldlist)
                    else
                        {}
                        },1000)
                },500)
            }
        }
        }
    })
   }
    setfieldandval(field){
        let formno = this.selectedform>-1?this.selectedform:0;
        if(field.length) // && !this.usersettingForm[formno].value 
        {
            for(let i = 0; i < field.length ; i++)
            {
                if(this.usersettingForm[formno].controls[this.selectedform + '_' + field[i].type + '_' + i])
                {
                this.usersettingForm[formno].controls[this.selectedform + '_' + field[i].type + '_' + i].setValue(field[i].value);
                if(field[i].type == 'address')
                {
                    this.usersettingForm[formno].controls[this.selectedform + '_' + field[i].type + '_' + i + '_lat'].setValue(field[i].lat);
                    this.usersettingForm[formno].controls[this.selectedform + '_' + field[i].type + '_' + i + '_lng'].setValue(field[i].lng);
                    //this.usersettingForm[formno].addControl(this.selectedform + '_' + field[i].type + '_' + i + '_lng', new FormControl(field[i].lng));
                }
                }
                if(field[i].type == 'sp4' || field[i].type == 'sp3')
                    this.selections = field[i].value;
            }
        }
    }
   setfield(form,formno){
    if(formno != -1)
    {
    let field = form.fieldlist?form.fieldlist:null;
    this.commenttype = form.commenttype?form.commenttype:null;
    this.liketype = form.liketype?form.liketype:null;
    this.hasstate = form.hasstate?form.hasstate:null;
    /*
    if(!form.categories)
        this.category = form.name;
    else
        {
        this.categories = form.categories;
        }*/

    if(field.length) // && !this.usersettingForm[formno].value 
    {

        for(let i = 0; i < field.length ; i++)
        {
            if(field[i].mustfill)
                this.usersettingForm[formno].addControl(this.selectedform + '_' + field[i].type + '_' + i, new FormControl('', Validators.compose([Validators.required])))
            else
                this.usersettingForm[formno].addControl(this.selectedform + '_' + field[i].type + '_' + i, new FormControl(''));
            if(field[i].type == 'address')
            {
                this.usersettingForm[formno].addControl(this.selectedform + '_' + field[i].type + '_' + i + '_lat', new FormControl(''));
                this.usersettingForm[formno].addControl(this.selectedform + '_' + field[i].type + '_' + i + '_lng', new FormControl(''));
            }
            if(field[i].type == 'sp4')
              this.formsp = field[i].sfield;
        }
    }
    }
   }

   selectcat(cat){
    this.category = cat.name; 
    this.categorytype = cat.type?cat.type:'normal';
    this.selectedform = (cat.defaultpostform==0 || cat.defaultpostform)?cat.defaultpostform:-1;
    this.setfield(this.forms[this.selectedform],this.selectedform)
   }

  ionViewDidLeave(){
    this.outlet.swipeGesture = true;
  }

  ngOnInit() { 
    if(this.outlet)
        this.outlet.swipeGesture = false;
    if(`${this.ch}` != 'undefined')
      this.chid = `${this.ch}`;
    if(`${this.item}` != 'undefined')
      this.itemid = `${this.item}`;
    this.cangoback = this.outlet && this.outlet.canGoBack();
    this.afDB.database.ref('/category/' + this.chid).once('value').then(chdata=>{
        let chinfo = chdata.val();
        if(chinfo)
        {
            this.defaultpost = chinfo.defaultpost;
            this.chname = chinfo.name;
            this.chloc = chinfo.loc;

            this.chowner = (firebase.auth().currentUser.uid == chinfo.userId || this.gv.manager) ? true:false; //|| firebase.auth().currentUser.uid  == 'NjQizqLkBINRT9LF9oHjmMing403'
            
            if(chinfo.category)
            {
                chinfo.category.forEach(cat=>{
                    if(cat.type == 'notice' && this.chowner)
                        this.categories.push(cat);
                    else if(cat.type != 'notice')
                        this.categories.push(cat);
                })
            }
            //this.categories = chinfo.category;
            this.publiccommunity = chinfo.publiccommunity;
            if(!this.publiccommunity)
                this.privateitem = true;
            //이하 폼 갯수파악
            if(this.defaultpost != 'hidden')
                this.formcount.push(-1);
            this.categories.forEach(c=>{
                let chkexist = false;
                for(let k = 0; k < this.formcount.length; k++)
                {
                    if(c.defaultpostform && (c.defaultpostform == this.formcount[k]))
                    {
                        chkexist = true;
                        break;
                    }
                }
                if(!chkexist && (c.defaultpostform == 0 || c.defaultpostform))
                    this.formcount.push(c.defaultpostform);
            })

            if(chinfo.subcategory)
                this.subcategories = chinfo.subcategory;
            if(chinfo.forms)
                this.forms = chinfo.forms?chinfo.forms:[];
            if(!this.itemid)
            {
                this.gv.getPostcover(this.chid).then(postcover=>{
                    if(postcover)
                    {
                        //console.log(postcover);
                        this.translate.get("Recovered temporary saved posting.").subscribe(res=>{
                        this.presentToast(res);});
                        let temppost = postcover;
                        //this.usersettingForm[this.selectedform].setValue = this.gv.postcover.form,
                        this.title = temppost['title'];
                        this.content = temppost['description'];
                        
                        this.images_post = temppost['images'];
                        if(this.images_post.length)
                            this.selectedimg = this.images_post[0].url;
                        this.imagethumbs_post = temppost['imagethumb'];
                        this.lat = temppost['lat'];
                        this.lng = temppost['lng'];
                        this.chid = temppost['categoryId'];
                        this.category = temppost['category'];
                        this.categorytype = temppost['categorytype'];
                        this.chname = temppost['communityname'];
                        this.imgtype = temppost['imgtype'];
                        this.selectedform = temppost['selectedform'];
                        this.commenttype = temppost['commenttype'];
                        this.liketype = temppost['liketype'];
                        this.hasstate = temppost['state'];
                        this.selections = temppost['selections'];
                        this.setfield(this.forms[this.selectedform], this.selectedform);
                        if(temppost['form'])
                        setTimeout(_=>{
                            let field = temppost['form'];
                            let formno = this.selectedform;
                            for(let i = 0; i < Object.keys(field).length ; i++)
                            {
                                let key = Object.keys(field)[i];
                                if(this.usersettingForm[formno].controls[key])
                                    this.usersettingForm[formno].controls[key].setValue(field[Object.keys(field)[i]]);
                            }
                        },500)
                    }
                    else if(chinfo.category)
                    {
                    if(this.gv.tossedcat)
                    {
                        this.category = this.gv.tossedcat;
                        this.gv.tossedcat = null;
                        for(let i = 0; i < this.categories.length; i++)
                        {
                            if(this.categories[i].name == this.category && (this.categories[i].defaultpostform == 0 || this.categories[i].defaultpostform))
                            {
                                this.selectedform = this.categories[i].defaultpostform;
                                this.setfield(this.forms[this.categories[i].defaultpostform], this.categories[i].defaultpostform)
                            }
                        }
                    }
                    else
                    {
                    this.selectedform = (this.categories[0].defaultpostform == 0 || this.categories[0].defaultpostform)?this.categories[0].defaultpostform:this.defaultpost == 'hidden'?0:-1;
                        if(this.forms.length > 0 && this.selectedform > -1)
                        {
                        if(this.defaultpost == 'hidden'? this.forms.length > 1 : this.forms.length+1 > 1)
                            this.category = this.categories[0].name;
                        this.setfield(this.forms[this.selectedform], this.selectedform)
                        }
                        else if (this.selectedform == -1 && this.categories.length == 1)
                        {
                            if(this.gv.tossedcat)
                            {
                                this.category = this.gv.tossedcat;
                                this.gv.tossedcat = null;
                            }
                            else
                                this.category = this.categories[0].name;
                        }
                    }
                    }
                })
            }
        }
        let today = new Date();
        let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
        this.afDB.database.ref('/systemlog/' + (firebase.auth().currentUser.uid?firebase.auth().currentUser.uid:'unregister') + '/event/' + todaystr + '/postenter').transaction(view=>{
            return (view || 0) + 1;
        })
    }).then(_=>{
        if(this.itemid)
            this.setdata();
     });
    this.autosave = setInterval(_=>{
        this.tempsave();
    },15000);
  }

//   ionViewDidEnter() {
//     this.setEndOfContenteditable(document.getElementById('editor'));
//   }

  ngOnDestroy() {
    clearInterval(this.autosave);
    this.subs.unsubscribe();
  }
  
  setautocomplete(targetid){
    setTimeout(__=>{
    var input = document.getElementById(targetid+'_ipaddress').getElementsByTagName('input')[0];
    var autocomplete = new google.maps.places.Autocomplete(input);
    //autocomplete.bindTo('bounds', this.map);
    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(['address_components','name','geometry']);
    autocomplete.addListener('place_changed', _=> {
          //this.maploading = true;
          var place = autocomplete.getPlace();
          var address = '';
          if (place.address_components) {
            address = [
              (place.address_components[0] && place.address_components[0].short_name || ''),
              (place.address_components[1] && place.address_components[1].short_name || ''),
              (place.address_components[2] && place.address_components[2].short_name || '')
            ].join(' ');
          }
          if(address)
          {this.usersettingForm[this.selectedform].controls[targetid].setValue(address);
          this.preaddress = address;
          if(place.geometry){
            this.usersettingForm[this.selectedform].controls[targetid+'_lat'].setValue(place.geometry.location.lat());
            this.usersettingForm[this.selectedform].controls[targetid+'_lng'].setValue(place.geometry.location.lng()) //this.lng[targetid] = place.geometry.location.lng();
            this.mapshow = true;
          }
          }
        //this.maploading = false
        }); }, 500)
  }
  /*linechk(ev){
    var breaklines = (ev.target.value.split(/\r?\n|\r/)).length;
    var textlines = 0;//ev.target.value.length / 30;
    if(Math.round(textlines) + breaklines == 1)
      ev.target.rows = 2;
    else
      ev.target.rows = Math.round(textlines) + breaklines
  }*/

  addressvalchange(e,targetid)
  {
     // if(this.preaddress != e.target.value)
        this.getlocation(e.target.value, targetid);
  }
  addresschkenter(e,targetid){
    this.addressvalchange(e,targetid);
  }
  getlocation(address, targetid){
  //this.maploading = true;
  let geocoder = new google.maps.Geocoder();
  geocoder.geocode({
          'address': address
      }, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
              this.usersettingForm[this.selectedform].controls[targetid+'_lat'].setValue(results[0].geometry.location.lat());// this.lat = results[0].geometry.location.lat();
              this.usersettingForm[this.selectedform].controls[targetid+'_lng'].setValue(results[0].geometry.location.lng());//this.lng = results[0].geometry.location.lng();
          }
          else{
            this.usersettingForm[this.selectedform].controls[targetid+'_lat'].setValue(null);//this.lat[targetid] = null;
            this.usersettingForm[this.selectedform].controls[targetid+'_lng'].setValue(null); //this.lng[targetid] = null;
          }
          //this.maploading = false;
      })
}

async showcategory(){
    if(this.subcategories.length > 0)
        this.opendoublecatmodal();
    else
        this.opencatselect();
}
async opencatselect(){
    let sltitem = [];
    this.categories.forEach(cat=>{
        sltitem.push({text:cat.name,handler:()=>{this.category = cat.name; this.categorytype = cat.type?cat.type:'normal';}}); 
    })
    let hd;
    this.translate.get('Select category').subscribe(res=>{hd=res});

    const actionsheet = await this.actionsheetCtrl.create({
      header: hd,
      buttons: sltitem
    });
    return await actionsheet.present();
}

  async opendoublecatmodal() {
    const modal = await this.modalCtrl.create({
      component: DoublecatmodalPage,
      componentProps:<null> {maincat:this.categories, subcat:this.subcategories, selected:this.category?this.category:''},
      cssClass: 'basicmodal fixed-bottom radius-top fullwidth'
    });
    modal.onDidDismiss().then(rst=>{
      if(rst && rst.data)
        this.category = rst.data;
    })
    return await modal.present();
  }

async showselection(item, targetid){
    var columnset;
    if(item.type == 'date')
        columnset = this.getdatepickarray(item.maxday,item.time,this.usersettingForm[this.selectedform].value[targetid]);
    else
        columnset = item.columns;

    let confirm;
    this.translate.get('Confirm').subscribe(res=>{confirm=res});
    const picker = await this.pickerCtrl.create({
      columns: columnset,
      buttons: [
      {
        text: confirm,
        handler: (data) => {
            
          if(item.type == 'date')
            {
              if(item.time)
                this.usersettingForm[this.selectedform].controls[targetid].setValue(data.date.value + ' ' + data.ampm.value + ' ' + data.hour.value + ' ' + data.min.value);
              else
                this.usersettingForm[this.selectedform].controls[targetid].setValue(data.date.value);
            }
          else
            {
                var tempval = '';
                  
                for(let i = 0; i < columnset.length; i++)
                {
                    if(tempval)
                    {
                        if(item.separator)
                            tempval += item.separator + data[Object.keys(data)[i]].value;
                        else
                            tempval += ' ' + data[Object.keys(data)[i]].value;
                    }
                        
                    else
                        tempval = data[Object.keys(data)[i]].value;
                }  
               // console.log(tempval);
                this.usersettingForm[this.selectedform].controls[targetid].setValue(tempval);
            }
        }
      }
    ]});
    await picker.present();
}
  


  addselection(){
    this.selections.push({isclosed:false});
  }
  removeselection(i){
    this.selections.splice(i, 1); 
  }
  async showslt(s, i, val){
    let columnset;
    if(i == 1)
      columnset = this.getdatepickarray(this.formsp[i].maxday, this.formsp[i].time, val);
    else{
      
      if(val)
      {
      var sltindex = 0;
      var tempoptions = [];
      for(let k = 0; k < this.formsp[i].items.length; k++)
      {
      tempoptions.push(this.formsp[i].items[k]);
      if(this.formsp[i].items[k].text == val)
        sltindex = k;
      }
      columnset = // [{name:'slt', selectedIndex:setsltindex?setsltindex:0, options:tempoptions}];
      [
        {
            name: 'slt',
            selectedIndex:sltindex,
            options: tempoptions
        }]
      }
      else
      columnset = [{name:'slt', options:this.formsp[i].items}];
      
    }
    let confirm;
    this.translate.get('Confirm').subscribe(res=>{confirm=res});
    const picker = await this.pickerCtrl.create({
      columns: columnset,
      buttons: [
      {
        text: confirm,
        handler: (data) => {
          this.selections[s]['val' + i + 'lbl'] = this.formsp[i].name;
          if(i == 1)
            {
              if(this.formsp[i].time)
                {
                this.selections[s]['val' + i] = data.date.value + ' ' + data.ampm.value + ' ' + data.hour.value + ' ' + data.min.value;
                //this.selections[s]['val' + i +'t'] = data.ampm.value + ' ' + data.hour.value + ' ' + data.min.value;
              }
              else
                this.selections[s]['val' + i] = data.date.value;
            }
          else
            {
            this.selections[s]['val' + i] = data.slt.text;
            }
        }
      }
    ]});
    await picker.present();
  }

  getdatepickarray(maxday,time, val){
    let suntosat,amstr,pmstr,minstr,hourstr,monthstr,daystr;
    this.translate.get('Sun-Sat').subscribe(res=>{suntosat=res});
    this.translate.get('AM').subscribe(res=>{amstr=res});
    this.translate.get('PM').subscribe(res=>{pmstr=res});
    this.translate.get('Min').subscribe(res=>{minstr=res});
    this.translate.get('Hour').subscribe(res=>{hourstr=res});
    this.translate.get('Monthstr').subscribe(res=>{monthstr=res});
    this.translate.get('Daystr').subscribe(res=>{daystr=res});


    var sltindex = [];
    var valsplit = val.split(' ');
    var temparray = [];

    var timenow = new Date();
    var datearray = [];
    var ampm = [];
    var hour = [];
    var min = [];
    var dayarray = suntosat.split(',');
    if(!maxday)
        maxday = 30;
    for(let i = 0 ; i < maxday; i++)
    {
        if(this.gv.lan == 'en')
        {
            var arraydate = new Date(timenow.getTime() + (1000*60*60*24*i))
            var montharray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var arraystr = 
            dayarray[arraydate.getDay()] + ' ' + montharray[(arraydate.getMonth())] + ' ' +
            arraydate.getDate(); 
            datearray.push({text:arraystr, value:arraystr.replace(' ', ',').replace(' ','/')});//value:arraystr.replace(/ /g, '')
            if(arraystr.replace(' ', ',').replace(' ','/') == valsplit[0])
            sltindex[0] = i;
        }
        else{
            var arraydate = new Date(timenow.getTime() + (1000*60*60*24*i))
            var arraystr = 
            (arraydate.getMonth()+1) + monthstr + ' ' +
            arraydate.getDate() + daystr + ' (' +
            dayarray[arraydate.getDay()] + ')'; 
            datearray.push({text:arraystr, value:arraystr.replace(/ /g, '')});
            if(arraystr.replace(/ /g, '') == valsplit[0])
            sltindex[0] = i;
        }
    }
    if(time)
    {
    ampm.push({text:amstr,value:amstr})
    ampm.push({text:pmstr,value:pmstr})

    if(valsplit[1] == pmstr)
      sltindex[1] = 1;
    
    for(let i = 0 ; i < 12; i++)
    {
        hour.push({text:(i+1) + hourstr,value:(i+1) + hourstr})
        if(valsplit[2] == (i+1) + hourstr)
          sltindex[2] = i;
    }
    for(let i = 0 ; i < 12; i++)
    {
        if(i < 2)
            min.push({text:'0' + (i*5) + minstr,value:'0' + (i*5) + minstr})
        else
            min.push({text:(i*5) + minstr,value:(i*5) + minstr})
        if(valsplit[3] == (i*5) + minstr)
          sltindex[3] = i;
    }
    if(this.gv.lan == 'en')
        temparray = [
        {
            name: 'date',
            columnWidth:'50%',
            selectedIndex:sltindex[0]?sltindex[0]:0,
            options: datearray
        },
        {
            name: 'hour',
            selectedIndex:sltindex[2]?sltindex[2]:0,
            columnWidth:'17%',
            options: hour
        },{
            name: 'min',
            selectedIndex:sltindex[3]?sltindex[3]:0,
            columnWidth:'17%',
            options: min
        },{
            name: 'ampm',
            columnWidth:'16%',
            selectedIndex:sltindex[1]?sltindex[1]:0,
            options: ampm
        }
        ];
    else
        temparray = [
            {
                name: 'date',
                columnWidth:'50%',
                selectedIndex:sltindex[0]?sltindex[0]:0,
                options: datearray
            },
            {
                name: 'ampm',
                columnWidth:'16%',
                selectedIndex:sltindex[1]?sltindex[1]:0,
                options: ampm
            },{
                name: 'hour',
                selectedIndex:sltindex[2]?sltindex[2]:0,
                columnWidth:'17%',
                options: hour
            },{
                name: 'min',
                selectedIndex:sltindex[3]?sltindex[3]:0,
                columnWidth:'17%',
                options: min
            },
        ];
    }
    else
    {
      temparray = [
        {
            name: 'date',
            selectedIndex:sltindex[0]?sltindex[0]:0,
            options: datearray
        }]
    }
    return temparray;
  }

  imgforceinsert(img){
      this.content += '<img src=\'' + img + '\'>';
  }

  imgview(i){
    if(this.images_post[i].url != this.selectedimg)
    {this.selectedimg = this.images_post[i].url; this.imgloaddone = false;}
  }

//   scrollchk(){
//     if(this.gv.cordova)  
//     this.ioncontent.scrollByPoint(0,200,500);
//   }

  async removeimg(i){
    let confirm,msg,cancel;
    this.translate.get('Would you like to delete this image?').subscribe(res=>{msg=res});
    this.translate.get('Cancel').subscribe(res=>{cancel=res});
    this.translate.get('Confirm').subscribe(res=>{confirm=res});
    
    const alert = await this.alertCtrl.create({
    message: msg,
    buttons: [
      {
        text: cancel,
        role: 'cancel'
      },{
        text: confirm,
        handler: () => {
          let tempimgurl = this.images_post[i].url;
          this.imguploadpost.delete(this.images_post[i].path, this.imagethumbs_post[i].path);
          this.imagethumbs_post.splice(i, 1); 
          this.images_post.splice(i, 1); 
          
          if(this.imagethumbs_post.length < 1) 
          {
            this.selectedimg = null;
          }
          else if(this.selectedimg == tempimgurl)
          {
            if(!this.imagethumbs_post[i])
              this.imgview(i-1);
            else
              this.imgview(i);
          }
            
        }
      }
    ]});
    await alert.present();
  }
  
/*
  async delimg(index){
    const alert = await this.alertCtrl.create({
    message: '사진을 삭제하시겠습니까?',
    buttons: [
      {
        text: '취소',
        role: 'cancel'
      },{
        text: '확인',
        handler: () => {
          this.imagethumbs_post.splice(index,1);
        }
      }
    ]});
    await alert.present();
  }*/

  addImgTop(){
    if(this.gv.cordova)
     this.nativeupload();
    else
     document.getElementById('imgfilespost').click();
  }

  private getBlob(b64Data:string, contentType:string, sliceSize:number= 512) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {type: contentType});
    return blob;
}

  nativeupload(){
      // outputtype 0 is fileuri 1 base64!
    this.imagePicker.getPictures({outputType:1,title:'나의 앨범'}).then((results) => {
      this.nativeimg_helper(results);
    }, (err)=>{console.log('err!!!!');console.log(err)});
  }

 async nativeimg_helper(results){
    var filelength = results.length;
      var currentimglength = this.images_post.length;
      let count = filelength;
      if(filelength)
        this.uploadingimgs = true;
      
      for(var i = 0; i < filelength; i++)
      {
      let type = '.jpeg';

      if(results[i].charAt(1) == 'i')
        type = '.png';
      else if(results[i].charAt(1) == 'R')
        type = '.gif';
      else if(results[i].charAt(1) == 'U')
        type = '.webp';

      let blob = this.getBlob(results[i], type)
      var file:File = new File([blob], "img" + new Date().getTime() + type)
      this.images_post.push({url:'loading',path:file.name});
      this.imagethumbs_post.push({url:'loading',path:file.name});
      
      await this.imguploadpost.readfile(file).then(rst=>
      {
      this.imguploadpost.imgnativeupload(file, 'communityimg')
      .then(imgrst=>{
        if(i == results.length){
            this.selectedimg = imgrst[0]['url'];
        }
        for(let j = 0; j < this.imagethumbs_post.length; j++)
        {
            if(this.images_post[j].url == 'loading'
            && imgrst[0]['path'].indexOf(this.imagethumbs_post[j].path) > -1)
            {
                this.images_post.splice(j,1,{path:imgrst[0]['path'], url:imgrst[0]['url']});
                this.imagethumbs_post.splice(j,1,{path:imgrst[1]['path'], url:imgrst[1]['url']});
            }
        }
        
        count--;
        if(count == 0) // 모두 다 들어갔을때 이미지 재정렬 및 로딩스피너 숨김 처리
        {
            
            //console.log('원래들어온순서');
            //console.log(this.images_post);
            this.uploadingimgs = false;
        }
      })
      })
      }
 }

  tempimgs: any = [];
  tempimgtbs: any = [];
  async htmlupload_post(fileinput:HTMLInputElement, folder?) { 
      //if(this.images_post.length > 0 && this.imagethumbs_post.length > 0)
      //  this.imguploadpost.delete(this.images_post[0].path, this.imagethumbs_post[0].path);
      //this.images_post = [];
      //this.imagethumbs_post = [];
      var filelength = fileinput.files.length;
      var currentimglength = this.images_post.length;
      let count = filelength;
      if(filelength)
        this.uploadingimgs = true;
      
      for(var i = 0; i < filelength; i++)
      {
      var file:File = fileinput.files[i];
      this.images_post.push({url:'loading',path:file.name});
      this.imagethumbs_post.push({url:'loading',path:file.name});

      await this.imguploadpost.readfile(file).then(rst=>
      {
      this.imguploadpost.imgupload(file, 'communityimg')// 'testimg')
      .then(imgrst=>{
        if(i == fileinput.files.length){
            this.selectedimg = imgrst[0]['url'];
        }
        for(let j = 0; j < this.imagethumbs_post.length; j++)
        {
            if(this.images_post[j].url == 'loading'
            && imgrst[0]['path'].indexOf(this.imagethumbs_post[j].path) > -1)
            {
                this.images_post.splice(j,1,{path:imgrst[0]['path'], url:imgrst[0]['url']});
                this.imagethumbs_post.splice(j,1,{path:imgrst[1]['path'], url:imgrst[1]['url']});
            }
        }
        
        count--;
        if(count == 0) // 모두 다 들어갔을때 이미지 재정렬 및 로딩스피너 숨김 처리
        {
            this.uploadingimgs = false;
        }
      })
      })
      }  
  }
    
  onPaste(ev){
      //console.log(ev);
  }


  async addmap(){
      const modal = await this.modalCtrl.create({
      component: AddmapPage,
      cssClass: 'basicmodal radius',
      backdropDismiss: true
    });
    modal.onDidDismiss().then(m=>{
        if(m.data && m.data.tag)
        this.content += '<br>' + m.data.tag + '<br><br>'
        //this.content += '<br>' + m.data.tag + ' <br><br>';
    })
    return await modal.present();
  }

  async addlink(){
    let linktype,ch,web,movie;
    this.translate.get('Link type').subscribe(res=>{linktype=res});
    this.translate.get('Channel Post').subscribe(res=>{ch=res});
    this.translate.get('Web Url').subscribe(res=>{web=res});
    this.translate.get('Movie(URL)').subscribe(res=>{movie=res});
    const actionsheet = await this.actionsheetCtrl.create({
      header: linktype,
      buttons: [{
        text: ch,
        icon: 'newspaper',
        cssClass: 'attach_chpost_icon',
        handler: () => {
            this.addinapplink();
        }
      }, {
        text: web,
        icon: 'link',
        cssClass: 'attach_exurl_icon',
        handler: () => {
          this.addurl();
        }
        }, {
        text: movie,
        icon: 'videocam',
        cssClass: 'attach_vidurl_icon',
        handler: () => {
          this.addmovie();
        }
        }]
    });
    return await actionsheet.present();}

   async addinapplink() {
    const modal = await this.modalCtrl.create({
        component: InapplinkPage,
        cssClass: 'ph-custom-modal',
        backdropDismiss: true
    });
    modal.onDidDismiss().then(m=>{
        if(m.data && m.data.tag)
        this.content += '<br>' + m.data.tag + '<br><br>';
    })
    return await modal.present();}


  async addurl() {
    const modal = await this.modalCtrl.create({
      component: BasicpopupPage,
      cssClass: 'basicmodal radius',
      backdropDismiss: true
      // componentProps: { value: 123 }
    });
    modal.onDidDismiss().then(m=>{
        if(m.data && m.data.tag)
        this.content += '<br>' + m.data.tag + '<br><br>';
    })
    return await modal.present();
  }

  async addmovie(){
    var addmovmsg, confirmbtn, cancelbtn, msgdetail;
    this.translate.get('Add movie').subscribe(res=>{
     addmovmsg = res;
    });
    this.translate.get('Fill in the movie address ex').subscribe(res=>{
      msgdetail = res;
    });
    this.translate.get('Confirm').subscribe(res=>{
      confirmbtn = res;
    });
    this.translate.get('Cancel').subscribe(res=>{
      cancelbtn = res;
    });
    const alert = await this.alertCtrl.create({
            header: addmovmsg,
            message: msgdetail,
            inputs: [
                {name: 'addr'}
            ],
            buttons: [
                {
                text: cancelbtn
                },
                {
                text: confirmbtn,
                handler: data => {
                  if(data.addr.trim())
                  {
                  if(data.addr.indexOf("http://") != 0 && data.addr.indexOf("https://") != 0)
                    {
                    data.addr = "https://" + data.addr;
                    }
                    this.content += "<br><div class=\"video_wrap\"><div class=\"video_container\"><iframe width='100%' height='250px' src='" + data.addr.replace("/youtu.be/", "/www.youtube.com/embed/") + "' frameborder='0' allowfullscreen></iframe></div></div><br><br>";
                    this.setEndOfContenteditable(document.getElementById('editor'));
                  }
                  else{
                    var addcanceled;
                    this.translate.get('Canceled because of no address').subscribe(res=>{
                    addcanceled = res;
                    });
                    this.presentToast(addcanceled);
                  }
                  }
                }
            ]
            });
    return await alert.present();
  }

  
/*
  async confirmlink() {
    const alert = await this.alertCtrl.create({
    mode:'ios',
    message: '',
    inputs: [
      {
        name: 'name',
        type: 'text',
        //value: url,
        placeholder: '링크주소(URL)를 입력해 주세요.'
      }
    ],
    buttons: [
      
      {
        text: '재검색',
        handler:(data)=>{
          this.addlink();
        }
      },
      {
        text: '확인',
        handler: (data) => {
          console.log(data.name);
        }
      }
    ]});
    await alert.present();
  }*/
/*
  testpoint()
  {
      this.pointfunc.addpoint(firebase.auth().currentUser.uid, 'posting', 10, '12311', null);
      console.log(firebase.auth().currentUser.uid);
  }*/

  async addImg(){
    let atsty,top,content;
    this.translate.get('Attach style').subscribe(res=>{atsty=res});
    this.translate.get('Attach all on top').subscribe(res=>{top=res});
    this.translate.get('Attach each on content').subscribe(res=>{content=res});
    
    const actionsheet = await this.actionsheetCtrl.create({
      header: atsty,
      buttons: [{
        text: top,
        cssClass: 'attach_top',
        handler: () => {
            this.imgtype = 'together';
            //if(!this.imgtype)
            //    this.imgtype = 'together';
            //else if(this.imgtype == 'inside')
            //    this.imgtype = 'both';
            //else if(this.imgtype == 'both')
            //    this.imgtype = 'inside';
            if(this.gv.cordova)
                this.nativeupload();
            else
                document.getElementById('imgfilespost').click();
        }
      }, {
        text: content,
        cssClass: 'attach_mid',
        handler: () => {
            this.imgtype = 'inside';
            /*
          if(!this.imgtype)
            this.imgtype = 'inside';
          else if(this.imgtype == 'together')
            this.imgtype = 'both';
          else if(this.imgtype == 'both')
            this.imgtype = 'together';*/
          if(this.gv.cordova)
            this.nativeupload()
          else
            document.getElementById('imgfilespost').click();
        }
        }]
    });
    return await actionsheet.present();
    
    //document.getElementById('imgfiles').click();
    }


  async submitForm(){    
      if(!this.category)
      {
        if(this.categories.length > 0)
            this.category = this.categories[0].name;
        else
            this.category = null; 
      }
      let formdata = [];
      let loadingPopup = await this.loadctrl.create({
            spinner: 'crescent',
            message: ''
        });
        loadingPopup.present();
        setTimeout(() => {   
            var weakmsg;
            this.translate.get('The network is weakness').subscribe(res=>{
            weakmsg = res;
            });
            loadingPopup.message = weakmsg;//animate(weakmsg);
        },2500);

        let today = new Date();
        let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
                    
      if(this.selectedform > -1)
        {
            if(this.forms[this.selectedform].imgattach)
                formdata['imgattach'] = true;
            else
                formdata['imgattach'] = '';
            formdata['name'] = this.forms[this.selectedform].name;
            var fieldlist = [];
            let fv = this.usersettingForm[this.selectedform].value;
            fv.title = '';
            fv.desc = '';

            for(let i = 0; i < this.forms[this.selectedform].fieldlist.length; i++)
            {
            let id = this.selectedform + '_' + this.forms[this.selectedform].fieldlist[i].type + '_' + i;
            let lat = null;
            let lng = null;
            if(this.forms[this.selectedform].fieldlist[i].type == 'address')
            {
                lat = fv[id+'_lat']?fv[id+'_lat']:null;
                lng = fv[id+'_lng']?fv[id+'_lng']:null;
            }

            if(this.forms[this.selectedform].fieldlist[i].type == 'sp4' 
            || this.forms[this.selectedform].fieldlist[i].type == 'sp3')
            {
                let seltxt = "";
                if(this.selections)
                for(let j = 0; j < this.selections.length; j++)
                {
                    if(this.selections[j].val0)
                        seltxt += this.formsp[0].name + " : " + this.selections[j].val0 + '<br>';
                    if(this.selections[j].val1)
                        seltxt += this.formsp[1].name + " : " + this.selections[j].val1 + '<br>';
                    if(this.selections[j].val2)
                        seltxt += this.formsp[2].name + " : " + this.selections[j].val2 + '<br>';
                    if(this.selections[j].val3)
                        seltxt += this.formsp[3].name + " : " + this.selections[j].val3 + '<br>';
                }
                else
                    this.selections = null;
                fv.desc? fv.desc += '<br>' + seltxt
                                : fv.desc = seltxt;
                
                fieldlist.push({name:this.forms[this.selectedform].fieldlist[i].name, 
                type:this.forms[this.selectedform].fieldlist[i].type, 
                mustfill: this.forms[this.selectedform].fieldlist[i].mustfill,
                value: this.selections});
            }
            else if(this.forms[this.selectedform].fieldlist[i].titlefield)
            {
                if(this.forms[this.selectedform].fieldlist[i].titlefield == '-')
                fv.title = fv[id];
                else
                fv.title = fv[id] + this.forms[this.selectedform].fieldlist[i].titlefield;
                fieldlist.push({name:this.forms[this.selectedform].fieldlist[i].name, type:this.forms[this.selectedform].fieldlist[i].type, 
                mustfill: this.forms[this.selectedform].fieldlist[i].mustfill, titlefield:this.forms[this.selectedform].fieldlist[i].titlefield,
                value:fv[id]?fv[id]:null, lat:lat, lng:lng});
            }
            else
            {
                if(fv[id])
                    fv.desc? fv.desc += '<br><br><b>' + this.forms[this.selectedform].fieldlist[i].name + "</b><br>" +fv[id]
                                : fv.desc = '<b>' + this.forms[this.selectedform].fieldlist[i].name + "</b><br>" +fv[id];
                fieldlist.push({name:this.forms[this.selectedform].fieldlist[i].name, 
                type:this.forms[this.selectedform].fieldlist[i].type, 
                mustfill: this.forms[this.selectedform].fieldlist[i].mustfill,
                value: fv[id]?fv[id]:null, lat:lat, lng:lng});
            }
            }
            formdata['fieldlist'] = fieldlist;

            //  서브밋
            if(this.itemid)
            {
                var pushitem = {};
                pushitem = {
                title:this.usersettingForm[this.selectedform].value.title,
                images:this.images_post,
                imagethumb:this.imagethumbs_post,
                lat:this.lat?this.lat:null,
                lng:this.lng?this.lng:null,
                //createdDate: firebase.database.ServerValue.TIMESTAMP,
                "formdata/fieldlist": formdata['fieldlist'],
                description:this.usersettingForm[this.selectedform].value.desc,
                //categoryId: this.chid,
                category:this.category,
                communityname:this.chname,
                communityloc:this.chloc,
                imgtype:this.imgtype,
                selectedform:this.selectedform,
                commenttype:this.commenttype,
                liketype:this.liketype,
                loc: this.gv.loc
                //state:this.hasstate
                //commenttype:feedback or private
                //category:this.forms[this.selectedform].name
                }
            
                this.fs.collection('post').doc(this.itemid).update(pushitem).then(rst=>{
                    loadingPopup.dismiss();
                    //업데이트 완료
                    this.translate.get("Updated the posing.").subscribe(res=>{
                    this.presentToast(res);});
                    this.afDB.database.ref('/systemlog/' + (firebase.auth().currentUser.uid?firebase.auth().currentUser.uid:'unregister') + '/event/' + todaystr + '/postedit').transaction(view=>{
                        return (view || 0) + 1;
                    })
                    this.closerequest = true;
                    this.gv.chreloadrequest = true;
                    this.gv.setPostcover(this.chid,null);
                    this.pageleave();
                }, error=>{
                    loadingPopup.dismiss();
                    this.translate.get("Please try again.").subscribe(res=>{
                    this.presentToast(res);});
                })
            }
            else
            {
                let title = this.usersettingForm[this.selectedform].value.title;
                var pushitem = {};
                pushitem = {
                userId: this.gv.uid,//firebase.auth().currentUser.uid,
                title:title,
                images:this.images_post,
                imagethumb:this.imagethumbs_post,
                lat:this.lat?this.lat:null,
                lng:this.lng?this.lng:null,
                type:'community',
                private:this.privateitem,
                up:0,
                down:0,
                read:0,
                replycount:0,
                createdDate: firebase.database.ServerValue.TIMESTAMP,
                formdata: formdata,
                description:this.usersettingForm[this.selectedform].value.desc,
                categoryId: this.chid,
                category:this.category,
                categorytype:this.categorytype,
                communityname:this.chname,
                communityloc:this.chloc,
                imgtype:this.imgtype,
                selectedform:this.selectedform,
                commenttype:this.commenttype,
                liketype:this.liketype,
                state:this.hasstate,
                loc: this.gv.loc
                //category:this.forms[this.selectedform].name
                }
                this.fs.collection('post').add(pushitem).then(rst=>{
                    loadingPopup.dismiss();
                    var msg;
                    this.translate.get('Posted the article').subscribe(res=>{
                    msg = res;
                    });
                    this.presentToast(msg);
                    this.afDB.database.ref('/userProfile/' + this.gv.uid + '/write').push({
                    itemid: rst.id, type:'community', chid:this.chid, loclancode:this.loclan, createdDate:firebase.database.ServerValue.TIMESTAMP
                    });
                    this.pointfunc.addpoint(firebase.auth().currentUser.uid, 'posting', 10, rst.id, null);
                    this.afDB.database.ref('/category/' + this.chid).once('value').then(com=>{
                        let channeldata = com.val();
                        if(channeldata.point)
                        {
                            this.afDB.database.ref('/category/' + this.chid).update({point:parseInt(channeldata.point)+3});
                        }
                        else
                            this.afDB.database.ref('/category/' + this.chid).update({point:3});
                        if(!this.privateitem)
                        {
                            if(channeldata.recent && Object.keys(channeldata.recent).length > 29)
                            {
                                //최근 판물 30개 꽉 차있으면 마지막항목 슬라이스 & 최근항목푸시
                                this.afDB.database.ref('/category/' + this.chid + '/recent/' + Object.keys(channeldata.recent)[0]).remove();
                                this.afDB.database.ref('/category/' + this.chid + '/recent').push({title:title, itemid: rst.id, createdDate:firebase.database.ServerValue.TIMESTAMP});
                            }
                            else
                            {
                                //최근 게시물 30개 없다면 최근항목푸시
                                this.afDB.database.ref('/category/' + this.chid + '/recent').push({title:title, itemid: rst.id, createdDate:firebase.database.ServerValue.TIMESTAMP});
                            }
                        }
                        if(this.notification)
                        {
                            var commsg, newcommsg;
                            this.translate.get('Community').subscribe(res=>{
                            commsg = res;
                            });
                            this.translate.get('New post on Community').subscribe(res=>{
                            newcommsg = res;
                            });
                            if(!this.privateitem)
                            {
                            this.msgfunc.sendnotionlywithcondition(commsg + '] ' + this.chname,title,newcommsg,this.chname + ': ' + title,'view'
                            ,rst.id, "'" + this.chid + "' in topics || '" + this.loclan + "_recent" + "' in topics");
                            }
                            else // 개인용 알람
                            {
                            this.msgfunc.sendnotionly(title,newcommsg,this.chname + ': ' + title,'view'
                            ,rst.id, this.chid);
                            }
                        }
                    })
                    this.translate.get("Post has done.").subscribe(res=>{
                    this.presentToast(res);});
                    this.afDB.database.ref('/systemlog/' + (firebase.auth().currentUser.uid?firebase.auth().currentUser.uid:'unregister') + '/event/' + todaystr + '/postwrite').transaction(view=>{
                        return (view || 0) + 1;
                    })
                    this.closerequest = true;
                    this.gv.chreloadrequest = true;
                    this.gv.setPostcover(this.chid,null);
                    this.pageleave();
                }, error=>{
                    loadingPopup.dismiss();
                    this.translate.get("Please try again.").subscribe(res=>{
                    this.presentToast(res);});
                })
            }
        }
        else{
            if(this.itemid)
            {
                var pushitem = {};
                pushitem = {
                title:this.title,
                images:this.images_post,
                imagethumb:this.imagethumbs_post,
                lat:this.lat?this.lat:null,
                lng:this.lng?this.lng:null,
                description:this.content,
                communityname:this.chname,
                communityloc:this.chloc,
                category:this.category,
                imgtype:this.imgtype,
                selectedform:this.selectedform,
                commenttype:this.commenttype,
                liketype:this.liketype,
                loc: this.gv.loc
                //state:this.hasstate
                //category:this.forms[this.selectedform].name
                }
            
                this.fs.collection('post').doc(this.itemid).update(pushitem).then(rst=>{
                    loadingPopup.dismiss();
                }).then(_=>{this.closerequest = true;
                    this.translate.get("Updated the posing.").subscribe(res=>{
                    this.presentToast(res);});
                    this.afDB.database.ref('/systemlog/' + (firebase.auth().currentUser.uid?firebase.auth().currentUser.uid:'unregister') + '/event/' + todaystr + '/postedit').transaction(view=>{
                        return (view || 0) + 1;
                    })
                    this.gv.chreloadrequest = true; this.gv.setPostcover(this.chid,null);
                    this.pageleave();});
            }
            else
            {
                var pushitem = {};
                pushitem = {
                userId: this.gv.uid,// firebase.auth().currentUser.uid,
                title:this.title,
                images:this.images_post,
                imagethumb:this.imagethumbs_post,
                lat:this.lat?this.lat:null,
                lng:this.lng?this.lng:null,
                type:'community',
                private:this.privateitem,
                up:0,
                down:0,
                read:0,
                replycount:0,
                createdDate: firebase.database.ServerValue.TIMESTAMP,
                description:this.content,
                categoryId: this.chid,
                category:this.category,
                categorytype:this.categorytype,
                communityname:this.chname,
                communityloc:this.chloc,
                imgtype:this.imgtype,
                selectedform:this.selectedform,
                commenttype:this.commenttype,
                liketype:this.liketype,
                state:this.hasstate,
                loc: this.gv.loc
                //category:this.forms[this.selectedform].name
                }

                this.fs.collection('post').add(pushitem).then(rst=>{
                    loadingPopup.dismiss();
                    var msg;
                    this.translate.get('Posted the article').subscribe(res=>{
                    msg = res;
                    });
                    this.presentToast(msg);
                    this.afDB.database.ref('/userProfile/' + this.gv.uid + '/write').push({
                    itemid: rst.id, type:'community', chid:this.chid, loclancode:this.loclan, createdDate:firebase.database.ServerValue.TIMESTAMP
                    });
                        this.pointfunc.addpoint(firebase.auth().currentUser.uid, 'posting', 10, rst.id, null);
                        this.afDB.database.ref('/category/' + this.chid).once('value').then(com=>{
                        let channeldata = com.val();
                        if(channeldata.point)
                        {
                            this.afDB.database.ref('/category/' + this.chid).update({point:parseInt(channeldata.point)+3});
                        }
                        else
                            this.afDB.database.ref('/category/' + this.chid).update({point:3});
                        if(!this.privateitem)
                        {
                            if(channeldata.recent && Object.keys(channeldata.recent).length > 29)
                            {
                                //최근 판물 30개 꽉 차있으면 마지막항목 슬라이스 & 최근항목푸시
                                this.afDB.database.ref('/category/' + this.chid + '/recent/' + Object.keys(channeldata.recent)[0]).remove();
                                this.afDB.database.ref('/category/' + this.chid + '/recent').push({title:this.title, itemid: rst.id, createdDate:firebase.database.ServerValue.TIMESTAMP});
                            }
                            else
                            {
                                //최근 게시물 30개 없다면 최근항목푸시
                                this.afDB.database.ref('/category/' + this.chid + '/recent').push({title:this.title, itemid: rst.id, createdDate:firebase.database.ServerValue.TIMESTAMP});
                            }
                        }
                        if(this.notification)
                        {
                            var commsg, newcommsg;
                            this.translate.get('Community').subscribe(res=>{
                            commsg = res;
                            });
                            this.translate.get('New post on Community').subscribe(res=>{
                            newcommsg = res;
                            });
                            if(!this.privateitem)
                            {
                            this.msgfunc.sendnotionlywithcondition(commsg + '] ' + this.chname,this.title,newcommsg,this.chname + ': ' + this.title,'view'
                            ,rst.id, "'" + this.chid + "' in topics || '" + this.loclan + "_recent" + "' in topics");
                            }
                            else // 개인용 알람. <검토필요>
                            {
                            this.msgfunc.sendnotionly(this.title,newcommsg,this.chname + ': ' + this.title,'view'
                            ,rst.id, this.chid);
                            }
                        }
                    })
                    this.translate.get("Post has done.").subscribe(res=>{
                    this.presentToast(res);});
                    this.afDB.database.ref('/systemlog/' + (firebase.auth().currentUser.uid?firebase.auth().currentUser.uid:'unregister') + '/event/' + todaystr + '/postwrite').transaction(view=>{
                        return (view || 0) + 1;
                    })
                    this.closerequest = true;
                    this.gv.chreloadrequest = true;
                    this.gv.setPostcover(this.chid,null);
                    this.pageleave();
                }, error=>{
                    loadingPopup.dismiss();
                    this.translate.get("Please try again.").subscribe(res=>{
                    this.presentToast(res);});
                })
            }
        }      
            
    }	

    async presentToast(message: string) {
    let toast = await this.toastCtrl.create({
    message: message,
    position: 'bottom',
    duration: 1500
    });
    toast.present();
    }

    bad_chkback(str){ // 욕 필터링 , 스크립트 아이프레임도 필터링
    if(str == '')
        return false;
    var badword;
    this.translate.get('badword').subscribe(res=>{
      badword = res;
    });
    var YokList = badword.replace(/\'/g, '').split(",");
    var Tmp = str;
    for(var i=0 ; i<YokList.length ; i++){
        var tempRegex = new RegExp(YokList[i], "ig");
        Tmp = Tmp.replace(tempRegex, '*'.repeat(YokList[i].length))
    }
    return Tmp;
    }

    setEndOfContenteditable(contentEditableElement)
    {
        var range,selection;
        if(document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
        {
            range = document.createRange();//Create a range (a range is a like the selection but invisible)
            range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
            range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
            selection = window.getSelection();//get the selection object (allows you to change selection)
            selection.removeAllRanges();//remove any selections already made
            selection.addRange(range);//make the range you have just created the visible selection
        }
            /*
        else if(document.selection)//IE 8 and lower
        { 
            range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
            range.moveToElementText(contentEditableElement);//Select the entire contents of the element with the range
            range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
            range.select();//Select the range (make it the visible selection
        }*/
    }
  
}

              